import React, { useState } from "react";
import { Icon } from "./Icon";

// Shown when /bot/status reports chatAccess === "missing": Twitch refused
// HAL's chat subscription, so HAL is "connected" but hears nothing. The only
// fix a streamer can do from their side is making the bot a moderator; the
// "Check again" button reconnects so the subscription is retried.
interface ChatAccessBannerProps {
  chatAccess?: "ok" | "missing" | "unknown";
  botUsername: string;
  onCheckAgain: () => Promise<void>;
}

export const ChatAccessBanner: React.FC<ChatAccessBannerProps> = ({
  chatAccess,
  botUsername,
  onCheckAgain,
}) => {
  const [checking, setChecking] = useState(false);

  if (chatAccess !== "missing") return null;

  const handleCheck = async () => {
    setChecking(true);
    try {
      await onCheckAgain();
    } finally {
      setChecking(false);
    }
  };

  return (
    <div
      role="alert"
      style={{
        maxWidth: "900px",
        margin: "0 auto 16px",
        padding: "14px 18px",
        background: "rgba(245, 158, 11, 0.12)",
        border: "1px solid #F59E0B",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <Icon name="alert-triangle" size={18} color="#F59E0B" />
      <span
        style={{
          color: "#e2e8f0",
          fontSize: "14px",
          flex: 1,
          minWidth: "200px",
        }}
      >
        HAL can&apos;t read your chat yet, so it won&apos;t reply. Twitch only
        lets HAL in as a moderator: type{" "}
        <code
          style={{
            background: "rgba(15, 23, 42, 0.6)",
            padding: "1px 6px",
            borderRadius: "4px",
          }}
        >
          /mod {botUsername}
        </code>{" "}
        in your Twitch chat, then click Check again.
      </span>
      <button
        onClick={handleCheck}
        disabled={checking}
        style={{
          background: "linear-gradient(135deg, #9146FF, #00D4FF)",
          color: "#fff",
          border: "none",
          padding: "10px 20px",
          borderRadius: "8px",
          fontWeight: 600,
          cursor: checking ? "wait" : "pointer",
          opacity: checking ? 0.7 : 1,
        }}
      >
        {checking ? "Checking…" : "Check again"}
      </button>
    </div>
  );
};

export default ChatAccessBanner;
